import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import AuditResults from "@/components/audit/AuditResults";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReportPage() {
  const { id } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    let stopped = false;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/audit/${id}`);
        if (stopped) return;
        if (data.status === "done") {
          setDoc(data);
        } else if (data.status === "error") {
          setError("This audit could not be generated.");
        } else {
          timer.current = setTimeout(load, 3000);
        }
      } catch (e) {
        if (!stopped) setError("Report not found.");
      }
    };
    load();
    return () => {
      stopped = true;
      if (timer.current) clearTimeout(timer.current);
    };
  }, [id]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <p className="font-heading uppercase tracking-widest text-zinc-500" data-testid="report-error">{error}</p>
      </div>
    );
  }
  if (!doc) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="report-loading">
        <Loader2 className="h-8 w-8 text-brand animate-spin" />
      </div>
    );
  }
  return (
    <AuditResults
      result={{ id: doc.id, audit: doc.audit }}
      emailStatus={doc.email_status}
      onReset={() => (window.location.href = "/")}
    />
  );
}
